import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DashboardSettingsDTO } from '../models/DashboardSettingsDTO';

@Injectable({
  providedIn: 'root'
})
export class TableauReportService {

  public Tab: number = 0;

  private setting$: Subject<DashboardSettingsDTO> = new Subject();

  headers = new HttpHeaders()
  .append('Content-Type', 'application/x-www-form-urlencoded')
  .append('Access-Control-Allow-Headers', 'Content-Type')
  .append('Access-Control-Allow-Methods', 'POST')
  .append('Access-Control-Allow-Origin', '*');

  constructor() {
  }

  setData(setting : DashboardSettingsDTO) {
    this.setting$.next(setting);
  }

  getUrl(){
    return this.setting$.asObservable();
  }

}
